import { render, staticRenderFns } from "./APricingSlider.vue?vue&type=template&id=25925de0&"
import script from "./APricingSlider.vue?vue&type=script&lang=js&"
export * from "./APricingSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports